const formErrorMessages = {
  required: 'Please fill out this field.'
}

export default formErrorMessages
